var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "m47.131 13.172-2.48 4.43H42.17l-2.48-4.43v6.91H36.5V7.679h3.367l3.543 6.556 3.544-6.556h3.366v12.403h-3.189z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m47.131 13.172-2.48 4.43H42.17l-2.48-4.43v6.91H36.5V7.679h3.367l3.543 6.556 3.544-6.556h3.366v12.403h-3.189z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m47.131 13.172-2.48 4.43H42.17l-2.48-4.43v6.91H36.5V7.679h3.367l3.543 6.556 3.544-6.556h3.366v12.403h-3.189z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M55.909 12.729q-.71 0-.709.708v.975h3.012v-.975q0-.708-.709-.708zm5.05 7.176q-3.42.354-6.202.354-1.205 0-1.931-.727-.727-.726-.727-1.93v-4.253q0-1.329.744-2.073.762-.762 2.091-.762h3.544q1.329 0 2.073.762.762.744.762 2.073v3.278H55.2v.708q0 .266.177.443a.6.6 0 0 0 .443.178q1.754-.001 5.139-.266z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M55.909 12.729q-.71 0-.709.708v.975h3.012v-.975q0-.708-.709-.708zm5.05 7.176q-3.42.354-6.202.354-1.205 0-1.931-.727-.727-.726-.727-1.93v-4.253q0-1.329.744-2.073.762-.762 2.091-.762h3.544q1.329 0 2.073.762.762.744.762 2.073v3.278H55.2v.708q0 .266.177.443a.6.6 0 0 0 .443.178q1.754-.001 5.139-.266z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M55.909 12.729q-.71 0-.709.708v.975h3.012v-.975q0-.708-.709-.708zm5.05 7.176q-3.42.354-6.202.354-1.205 0-1.931-.727-.727-.726-.727-1.93v-4.253q0-1.329.744-2.073.762-.762 2.091-.762h3.544q1.329 0 2.073.762.762.744.762 2.073v3.278H55.2v.708q0 .266.177.443a.6.6 0 0 0 .443.178q1.754-.001 5.139-.266z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M62.546 15.12v-2.48h7.265v2.48z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M62.546 15.12v-2.48h7.265v2.48z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M62.546 15.12v-2.48h7.265v2.48z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M71.4 7.679h7.442q1.86 0 2.694.85.85.833.85 2.693v1.772q0 1.86-.85 2.711-.832.833-2.694.833H74.59v3.544H71.4zm7.797 3.543q0-1.062-1.063-1.063H74.59v3.898h3.544q1.063 0 1.063-1.063z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M71.4 7.679h7.442q1.86 0 2.694.85.85.833.85 2.693v1.772q0 1.86-.85 2.711-.832.833-2.694.833H74.59v3.544H71.4zm7.797 3.543q0-1.062-1.063-1.063H74.59v3.898h3.544q1.063 0 1.063-1.063z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M71.4 7.679h7.442q1.86 0 2.694.85.85.833.85 2.693v1.772q0 1.86-.85 2.711-.832.833-2.694.833H74.59v3.544H71.4zm7.797 3.543q0-1.062-1.063-1.063H74.59v3.898h3.544q1.063 0 1.063-1.063z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M93.37 17.424q0 1.33-.761 2.09-.744.745-2.073.745h-4.075q-1.329 0-2.091-.744-.744-.762-.744-2.091v-4.075q0-1.329.744-2.073.762-.762 2.09-.762h4.076q1.329 0 2.073.762.762.744.762 2.073zm-3.1-3.81q0-.708-.709-.708h-2.126q-.709 0-.709.708v3.544q0 .71.71.709h2.125q.71 0 .71-.709z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M93.37 17.424q0 1.33-.761 2.09-.744.745-2.073.745h-4.075q-1.329 0-2.091-.744-.744-.762-.744-2.091v-4.075q0-1.329.744-2.073.762-.762 2.09-.762h4.076q1.329 0 2.073.762.762.744.762 2.073zm-3.1-3.81q0-.708-.709-.708h-2.126q-.709 0-.709.708v3.544q0 .71.71.709h2.125q.71 0 .71-.709z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M93.37 17.424q0 1.33-.761 2.09-.744.745-2.073.745h-4.075q-1.329 0-2.091-.744-.744-.762-.744-2.091v-4.075q0-1.329.744-2.073.762-.762 2.09-.762h4.076q1.329 0 2.073.762.762.744.762 2.073zm-3.1-3.81q0-.708-.709-.708h-2.126q-.709 0-.709.708v3.544q0 .71.71.709h2.125q.71 0 .71-.709z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M94.61 17.601q3.596.266 5.669.266.266 0 .443-.177a.6.6 0 0 0 .177-.443v-.62h-3.81q-1.203 0-1.93-.727-.727-.726-.727-1.931v-.62q0-1.205.726-1.932.728-.726 1.932-.726h6.024v2.303h-4.961a.6.6 0 0 0-.443.178.6.6 0 0 0-.177.442q0 .267.177.443a.6.6 0 0 0 .443.178h3.189q1.205 0 1.932.726t.726 1.931v.71q0 1.204-.726 1.93-.727.727-1.932.727-3.135 0-6.733-.355z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M94.61 17.601q3.596.266 5.669.266.266 0 .443-.177a.6.6 0 0 0 .177-.443v-.62h-3.81q-1.203 0-1.93-.727-.727-.726-.727-1.931v-.62q0-1.205.726-1.932.728-.726 1.932-.726h6.024v2.303h-4.961a.6.6 0 0 0-.443.178.6.6 0 0 0-.177.442q0 .267.177.443a.6.6 0 0 0 .443.178h3.189q1.205 0 1.932.726t.726 1.931v.71q0 1.204-.726 1.93-.727.727-1.932.727-3.135 0-6.733-.355z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M94.61 17.601q3.596.266 5.669.266.266 0 .443-.177a.6.6 0 0 0 .177-.443v-.62h-3.81q-1.203 0-1.93-.727-.727-.726-.727-1.931v-.62q0-1.205.726-1.932.728-.726 1.932-.726h6.024v2.303h-4.961a.6.6 0 0 0-.443.178.6.6 0 0 0-.177.442q0 .267.177.443a.6.6 0 0 0 .443.178h3.189q1.205 0 1.932.726t.726 1.931v.71q0 1.204-.726 1.93-.727.727-1.932.727-3.135 0-6.733-.355z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#9D9D9D",
    d: "M27.85 14.175c0 7.552-6.123 13.675-13.675 13.675S.5 21.727.5 14.175 6.622.5 14.175.5C21.727.5 27.85 6.622 27.85 14.175Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.175,
    cy: 14.175,
    r: 5.316,
    fill: "#5842BE"
  })));
};
export default SvgLogo;